import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, image, url }) => {
  const siteTitle = "ACF Luxury Stays";
  const defaultDescription =
    "Boutique luxury vacation rentals in Telluride, Beaver Creek, San Diego, and Miami Beach.";
  const defaultImage = "https://acfluxurystays.com/og-image-default.jpg"; // You can replace this with a real URL later
  const siteUrl = "https://acfluxurystays.com";

  // If a specific title is provided, append the site name (unless it's already included)
  const fullTitle = title
    ? title.includes("|")
      ? title
      : `${title} | ${siteTitle}`
    : siteTitle;

  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const metaDescription = description || defaultDescription;
  const metaImage = image || defaultImage;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
};

export default SEO;
